export const trialBannerDismissedFlag = "trialBanner.dismissed";
